/** Station identifiers come from Flightline as 14-digit decimal strings.
 * The convention for display is uppercase hex (matches how identifiers are
 * shown in Flightline's own admin tooling). */
export function identifierAsHex(id: string): string {
  try {
    return BigInt(id).toString(16).toUpperCase();
  } catch {
    return id;  // fall back to raw string if not a valid integer
  }
}
